export const getCachedImage = (imageUrl) => {
  if (!imageUrl) return null;
  
  // Add a cache-busting parameter that changes daily
  // This ensures the image is cached for a day
  const cacheKey = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
  return `${imageUrl}?cache=${cacheKey}`;
}; 